import * as React from 'react';
import { cn } from '../lib/utils';

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'primary' | 'inverse';
}

const sizeMap = {
  sm: 'size-icon-sm border-2',
  md: 'size-icon-lg border-2',
  lg: 'h-10 w-10 border-[3px]',
};

const colorMap = {
  default: 'border-muted-foreground/30 border-t-foreground',
  primary: 'border-primary/30 border-t-primary',
  inverse: 'border-white/30 border-t-white',
};

export function Spinner({ className, size = 'md', color = 'default', ...props }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block animate-spin rounded-full',
        colorMap[color],
        sizeMap[size],
        className,
      )}
      {...props}
    />
  );
}
